import React, { useState, useEffect } from "react";
import Modal from "@cloudscape-design/components/modal";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Textarea from "@cloudscape-design/components/textarea";
import FormField from "@cloudscape-design/components/form-field";
import Container from "@cloudscape-design/components/container";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { groupStore } from "../stores/group";
import { groupAddModalStore } from "../stores/groupAddModal";

const addGroup = async (data) => {
	console.log("Adding group:", data);
	return { success: true, insertId: Math.random() };
};

class GroupAddModal extends React.Component {
	state = {
		name: this.props.groupAddModal.name || "",
		description: this.props.groupAddModal.description || "",
		permissions: this.props.groupAddModal.permissions
			? JSON.stringify(JSON.parse(this.props.groupAddModal.permissions), null, 2)
			: "",
		showColumn: this.props.groupAddModal.showColumn
			? JSON.stringify(JSON.parse(this.props.groupAddModal.showColumn), null, 2)
			: "",
		errors: {},
	};

	validateJSON = (value) => {
		try {
			if (!value.trim()) return false;
			JSON.parse(value);
			return true;
		} catch {
			return false;
		}
	};

	validateGroupFields = () => {
		const { name, description, permissions } = this.state;
		const errors = {};

		if (!name.trim()) errors.name = "Name is required";
		if (!description.trim()) errors.description = "Description is required";
		if (!permissions.trim()) {
			errors.permissions = "Permissions are required";
		} else if (!this.validateJSON(permissions)) {
			errors.permissions = "Invalid JSON format";
		}
		if (this.state.showColumn && !this.validateJSON(this.state.showColumn)) {
			errors.showColumn = "Invalid JSON format";
		}

		return errors;
	};

	handleInputChange = (field, value) => {
		this.setState({ [field]: value, errors: { ...this.state.errors, [field]: null } });
	};

	addGroup = async () => {
		const errors = this.validateGroupFields();
		if (Object.keys(errors).length > 0) {
			this.setState({ errors });
			return;
		}

		try {
			await this.props.Interface.request("set", { class: "panel", module: "group", method: "create" }, {
				name: this.state.name,
				description: this.state.description,
				permissions: this.state.permissions ? JSON.parse(this.state.permissions) : undefined,
				showColumn: this.state.showColumn ? JSON.parse(this.state.showColumn) : undefined,
			});
			this.props.Interface.loadGroup();
			this.props.setGroupAddModal({ show: false });
		} catch (error) {
			this.setState({ errors: { form: "Failed to add group" } });
		}
	};

	render() {
		const { groupAddModal, setGroupAddModal } = this.props;
		const { name, description, permissions, showColumn, errors } = this.state;

		return (
			<Modal
				visible={groupAddModal.show}
				onDismiss={() => setGroupAddModal({ ...groupAddModal, show: false })}
				header="Add Group"
				size="large"
				footer={
					<Box float="right">
						<SpaceBetween direction="horizontal" size="xs">
							<Button
								variant="normal"
								onClick={() => setGroupAddModal({ ...groupAddModal, show: false })}
							>
								Close
							</Button>
							<Button variant="primary" onClick={this.addGroup}>
								Save
							</Button>
						</SpaceBetween>
					</Box>
				}
			>
				<Container>
					<SpaceBetween direction="vertical" size="m">
						<FormField label="Name" errorText={errors.name} stretch>
							<Input
								value={name}
								placeholder="Name"
								onChange={({ detail }) => this.handleInputChange("name", detail.value)}
							/>
						</FormField>
						<FormField label="Description" errorText={errors.description} stretch>
							<Input
								placeholder="Description"
								value={description}
								onChange={({ detail }) => this.handleInputChange("description", detail.value)}
							/>
						</FormField>
						<FormField label="Permissions (JSON)" errorText={errors.permissions} stretch>
							<Textarea
								placeholder="Permissions (JSON)"
								value={permissions}
								onChange={({ detail }) => this.handleInputChange("permissions", detail.value)}
								rows={6}
							/>
						</FormField>
						<FormField label="Show Column (JSON, optional)" errorText={errors.showColumn} stretch>
							<Textarea
								placeholder="Show Column (JSON, optional)"
								value={showColumn}
								onChange={({ detail }) => this.handleInputChange("showColumn", detail.value)}
								rows={6}
							/>
						</FormField>
					</SpaceBetween>
				</Container>
				{errors.form && <Box color="text-status-error" margin={{ top: "s" }}>{errors.form}</Box>}
			</Modal>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const group = useRecoilValue(groupStore);
		const setGroup = useSetRecoilState(groupStore);
		const groupAddModal = useRecoilValue(groupAddModalStore);
		const setGroupAddModal = useSetRecoilState(groupAddModalStore);

		return (
			<Component
				{...props}
				group={group}
				setGroup={setGroup}
				groupAddModal={groupAddModal}
				setGroupAddModal={setGroupAddModal}
			/>
		);
	};
}

export default withRecoil(GroupAddModal);